export default {
    close: "tycka:close",
    awaitingConfiguration: "tycka:awaitingConfiguration",
    configured: "tycka:configured",
    configDone: "tycka:configDone",
    setConfig: "tycka:setConfig",
}